<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component({
        async setup() {
            const app = useNuxtApp()
            const $route = useRoute()
            const token = $route.query.token as string
            await useAsyncData('user-auto-login', async () => {
                if (import.meta.server) {
                    // TODO [P1] Need check
                    useCookie('token', {
                        secure: process.env.NODE_ENV !== 'development' && !app.$conf.public.disableSecureCookie,
                    }).value = token
                }
                navigateTo('/')
                return true
            })
        },
    })
    export class UserAutoLoginPage extends Vue {
        render() {
            return null
        }
    }

    export default UserAutoLoginPage
</script>
